import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenAuthService } from '@app/shared/token-auth.service';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private _tokenAuthService: TokenAuthService,
    private _router: Router
  ) {

  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    // Skip token injection for super admin API calls (they set their own token header)
    if (request.url.includes('/admin/')) {
      return next.handle(request);
    }

    const token = localStorage.getItem('token') ? localStorage.getItem('token') : "";
    return next.handle(request.clone({
      setHeaders: {
        token,
      } }));
  }
}